import React, { useState, useEffect,useRef } from 'react'
import RightArrow from '../../common/icons/right-arrow'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import TableLoader from '../../common/TableLoader'
import { _Api } from '../../api/_call'
const QuickStoreSetup = () => {
  const { t } = useTranslation()
  const dropdownRefname = useRef(null);
  const dropdownRefcode = useRef(null);
  const [shortobj, setShortobj] = useState({})
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
  const [quicksetuplist, setQuicksetuplist] = useState([])
  const [showloader, setShowloader] = useState(false);
  const [filtername, setFiltername] = useState('');
  const [locationfilter, setLocationfilter] = useState([])
  const [searchVal, setSearchVal] = useState("");
  const [locationchecked, setLocationChecked] = useState([])
  const [codechecked, setCodechecked] = useState([]);
  const [codefilter, setCodefilter] = useState([]);
  const hendledropdownhide = (lable) => {
    if (lable === "name") {
      dropdownRefname.current.classList.remove("show")
    } else if (lable === "code") {
      dropdownRefcode.current.classList.remove("show")
    }
  }
  const handleCheckAllChange = (e, lable) => {
    if (lable === "name") {
      setLocationChecked(e.target.checked ? locationfilter.map((c) => c) : []);
    } else if (lable === "code") {
      setCodechecked(e.target.checked ? codefilter.map((c) => c) : []);
    }
  }
  const handlefilerChange = (event, data, lable) => {
    if (lable === "name") {
      setLocationChecked((prevChecked) =>
        event.target.checked
          ? [...prevChecked, data]
          : prevChecked.filter((item) => item !== data)
      );
    }else if (lable === "code") {
      setCodechecked((prevChecked) =>
        event.target.checked
          ? [...prevChecked, data]
          : prevChecked.filter((item) => item !== data)
      );
    }
  }
  const quicksetup = async (searchTerm = filtername) => {
    setShowloader(true);
    try {
      let postdata = {
        "search": searchTerm,
        "filter": {
          "name": locationchecked ?? [],
          "code": codechecked ?? [], // NEW LINE
        },
        "sort": { [shortobj?.key]: shortobj?.value }
      }
      let res = await _Api(postdata, `api/v1/App/quicksetup/get-location-list`)
      if (res?.code === 200) {
        setQuicksetuplist(res?.data)
        setShowloader(false)
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }
    const locationfilterapi = async () => {
      try {
        let postdata = {}
        let res = await _Api(postdata, `api/v1/App/location/locationfilter`)
        if (res?.code === 200) {
          setLocationfilter(res?.data?.name)
          setCodefilter(res?.data?.code) // NEW LINE for code
        }
      } catch (err) {
        console.log(err)
      }
    }
    const getscarchvalue = async (event, lable) => {
      const query = searchVal ? searchVal : event.target.value ? event.target.value : "";
  
      if (lable === "name") {
        let updatedList = [...locationfilter];
        let arr = [];
        if (query) {
          updatedList.filter((item) => {
            if (item?.toLowerCase() === query.toLowerCase()) {
              arr.push(item);
            }
            return true;
          });
          setLocationfilter(arr);
        } else {
          locationfilterapi();
        }
      }  else if (lable === "code") {
        let updatedList = [...codefilter];
        let arr = [];
        if (query) {
          updatedList.filter((item) => {
            if (item?.toLowerCase() === query.toLowerCase()) {
              arr.push(item);
            }
            return true;
          });
          setCodefilter(arr);
        } else {
          locationfilterapi();
        }
      }
    };
  useEffect(() => {
    quicksetup("")
    locationfilterapi();
  }, [shortobj])
  return (
    <div className="main-content-wrapper-body setup-sticky-header">
      <div className="main-content-wrapper-body-top-bar d-flex align-items-center justify-content-between">
        <div className="main-content-wrapper-body-top-bar-left">
          <h1 className="main-content-wrapper-body-top-bar-left-heading fw-semibold mb-0">
            {t('Setup')} <RightArrow />{' '}
            <span className="">{t('Quick Store/Outlet Setup')}</span>
          </h1>
        </div>
        <div className="main-content-wrapper-body-top-bar-right d-flex align-items-center">
          <div className="com-search-bar position-relative">
            <img className="com-search-bar-search-img" src={base_assets + "images/admin/icons/gray-search.png"} alt="" />
            <input value={filtername} placeholder="Search Location" className="h-100 border-0 bg-transparent"
             onKeyPress={(e) => {
              if (e.key === 'Enter') {
                quicksetup(filtername);  // Call quicksetup with the current filtername value
              }
            }} // Use the handleFilterChange function on Enter
             onChange={(e) => setFiltername(e.target.value)} />
            {filtername && (
              <img
                className="main-body-top-status-bar-filter-clear"
                src={base_assets + 'images/icons/False.png'}
                onClick={() => {
                  setFiltername('');  // Clear the filter
                  quicksetup("");  // Call API with empty string
                }}
                alt="Clear Filter"
              />
            )}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div
            className="main-body-main-table-wrap com-custom-table table-responsive position-relative"
          >
            <table
              id="my_customer"
              className="com-custom-table-tag table align-middle"
            >
              <thead>
                <tr className="text-nowrap align-middle">
                  <th>#</th>
                  <th className="user-name-width">{t('Store / Outlet')}
                      <div className="dropdown d-inline-block com-custom-table-tag-filter">
                        <button className="after-none bg-transparent border-0 dropdown-toggle p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" >
                          <img className="ms-2 com-custom-table-tag-filter-img" src={base_assets + "images/icons/table-filter-icon.png"} alt=""></img>
                        </button>
                        <div className={"dropdown-menu com-custom-table-tag-filter-menu p-0 border-0 overflow-hidden"}
                          ref={dropdownRefname}>
                          <div className="asc-des-order">
                            <div onClick={() => { setShortobj({ key: "name", value: 1 }); hendledropdownhide("name") }} className="asc-des-order-single cursor-pointer"> <img src={base_assets + "images/icons/arrow-sort-up.png"} alt="" />{t("Sort Ascending")}</div>
                            <div onClick={() => { setShortobj({ key: "name", value: -1 }); hendledropdownhide("name") }} className="asc-des-order-single cursor-pointer"> <img src={base_assets + "images/icons/arrow-sort-down.png"} alt="" />{t("Sort Descending")}</div>
                          </div>
                          <div className="com-custom-table-tag-filter-menu-search">
                            <div className="com-custom-table-tag-filter-menu-search-inner d-flex align-items-center">
                              <img src={base_assets + "images/icons/search-icon.png"} alt="" />
                              <input className="border-0" type="text" placeholder="Search"
                                onKeyPress={(e) => e.key === 'Enter' && getscarchvalue(e, "name")}
                                onChange={(e) => setSearchVal(e.target.value)} />
                            </div>
                          </div>
                          <div className="com-custom-table-tag-filter-menu-select">
                            <div className="com-custom-table-tag-filter-menu-select-bar d-flex align-items-center justify-content-between">
                              <div>
                                <input className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer" type="checkbox" id="s1"
                                  onChange={(e) => handleCheckAllChange(e, "name")}
                                  checked={locationchecked.length === locationfilter.length} />
                                <label className="form-check-label cursor-pointer fw-semibold" htmlFor="s1">{t("Select All")}</label>
                              </div>
                              <label>{locationchecked.length}/{locationfilter.length} {t("Selected")}</label>
                            </div>
                            <ul className="com-custom-table-tag-filter-menu-select-list list-unstyled mt-3 ps-4">
                              {locationfilter?.length ? locationfilter.map((result, key) => {
                                return (
                                  <li className="com-custom-table-tag-filter-menu-select-list-single" key={key}>
                                    <input className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer" type="checkbox" id={key}
                                      checked={
                                        locationchecked ? locationchecked.includes(result) : ""
                                      }
                                      onChange={(e) => handlefilerChange(e, result, "name")} />
                                    <label className="form-check-label cursor-pointer" htmlFor={key}>{result}</label>
                                  </li>
                                )
                              }) : ""}

                            </ul>
                          </div>
                          <div className="com-custom-table-tag-filter-menu-btn-grp text-center d-flex align-items-center gap-2"
                          >
                            <button className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 bg-transparent fw-semibold graythemecolor" onClick={() => { setLocationChecked([]); setShortobj({}) }}>{t("Clear")}</button>
                            <button className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 main-green-bg text-white fw-semibold" onClick={() => { quicksetup(""); hendledropdownhide("name") }}>{t("Apply")}</button>
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>{t("Code")}
                      <div className="dropdown d-inline-block com-custom-table-tag-filter">
                        <button className="after-none bg-transparent border-0 dropdown-toggle p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                          <img className="ms-2 com-custom-table-tag-filter-img" src={base_assets + "images/icons/table-filter-icon.png"} alt="" />
                        </button>
                        <div className="dropdown-menu com-custom-table-tag-filter-menu p-0 border-0 overflow-hidden code" ref={dropdownRefcode}>
                          <div className="asc-des-order">
                            <div onClick={() => { setShortobj({ key: "code", value: 1 }); hendledropdownhide("code") }} className="asc-des-order-single cursor-pointer">
                              <img src={base_assets + "images/icons/arrow-sort-up.png"} alt="" />{t("Sort Ascending")}
                            </div>
                            <div onClick={() => { setShortobj({ key: "code", value: -1 }); hendledropdownhide("code") }} className="asc-des-order-single cursor-pointer">
                              <img src={base_assets + "images/icons/arrow-sort-down.png"} alt="" />{t("Sort Descending")}
                            </div>
                          </div>
                          <div className="com-custom-table-tag-filter-menu-search">
                            <div className="com-custom-table-tag-filter-menu-search-inner d-flex align-items-center">
                              <img src={base_assets + "images/icons/search-icon.png"} alt="" />
                              <input className="border-0" type="text" placeholder="Search"
                                onKeyPress={(e) => e.key === 'Enter' && getscarchvalue(e, "code")}
                                onChange={(e) => setSearchVal(e.target.value)} />
                            </div>
                          </div>
                          <div className="com-custom-table-tag-filter-menu-select">
                            <div className="com-custom-table-tag-filter-menu-select-bar d-flex align-items-center justify-content-between">
                              <div>
                                <input className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer" type="checkbox" id="c1"
                                  onChange={(e) => handleCheckAllChange(e, "code")}
                                  checked={codechecked?.length === codefilter?.length} />
                                <label className="form-check-label cursor-pointer fw-semibold" htmlFor="c1">{t("Select All")}</label>
                              </div>
                              <label>{codechecked?.length}/{codefilter?.length} {t("Selected")}</label>
                            </div>
                            <ul className="com-custom-table-tag-filter-menu-select-list list-unstyled mt-3 ps-4">
                              {codefilter?.length ? codefilter.map((result, key) => {
                                return (
                                  <li className="com-custom-table-tag-filter-menu-select-list-single" key={key}>
                                    <input className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer" type="checkbox" id={`code-${result}`}
                                      checked={codechecked ? codechecked.includes(result) : ""}
                                      onChange={(e) => handlefilerChange(e, result, "code")} />
                                    <label className="form-check-label cursor-pointer" htmlFor={`code-${result}`}>{result}</label>
                                  </li>
                                )
                              }) : ""}
                            </ul>
                          </div>
                          <div className="com-custom-table-tag-filter-menu-btn-grp text-center d-flex align-items-center gap-2">
                            <button className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 bg-transparent fw-semibold graythemecolor" onClick={() => { setCodechecked([]); setShortobj({}) }}>{t("Clear")}</button>
                            <button className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 main-green-bg text-white fw-semibold" onClick={() => { quicksetup(""); hendledropdownhide("code") }}>{t("Apply")}</button>
                          </div>
                        </div>
                      </div>
                    </th>
                  <th>{t('Type')}</th>
                  <th>{t('Cash Register')}</th>
                </tr>
              </thead>
              <tbody>
                {!showloader && quicksetuplist?.length ? quicksetuplist?.map((result, key) => {
                  return (
                    <tr className="text-nowrap" key={key}>
                      <td>{key + 1}</td>
                      <td>
                        <Link
                          to="/app/admin/setup/quickstoresetup/vouchertype"
                          className="text-decoration-none link-color"
                          state={{ location_id: result?._id }}
                        >
                          {result?.name && result?.name}
                        </Link>
                      </td>
                      <td>{result.code ? result.code : ""}</td>
                      <td>{result.type ? result.type : ""}</td>
                      <td>
                        <Link
                          to="/app/admin/setup/quickstoresetup/cashregister"
                          state={{
                            locationdata: result,
                          }}
                          className="main-green-text text-decoration-none"
                        >
                          <img
                            className="me-2"
                            src={
                              base_assets + 'images/icons/add-detail.png'
                            }
                            alt=""
                          />
                          {result?.CashRegister && result?.CashRegister}
                        </Link>
                      </td>
                    </tr>
                  )
                }) : null}
              </tbody>
            </table>
            {showloader && <TableLoader />}
          </div>
        </div>
      </div>
    </div >
  )
}

export default QuickStoreSetup
